<section class="confirm-email" *ngIf="!loading">
  <sbnb-user-header></sbnb-user-header>

  <article class="main">
    <ng-container>
      <h2 class="nomargin">{{ title }}</h2>
      <p *ngIf="error">{{ error }}</p>
      <p *ngIf="content">{{ content }}</p>
    </ng-container>
  </article>

  <aside *ngIf="error">
    <div style="height: 563px; display: flex; align-items: flex-end; justify-content: center">
      <img src="/assets/images/login/forgot-pw.svg" />
    </div>
  </aside>
</section>
<article class="main" *ngIf="loading">
  <mat-spinner diameter="32"></mat-spinner>
</article>
